import { gql } from '@apollo/client';
export const getComposerNameQuery = gql `
  query getComposerName($composerId: UUID!) {
    composer(id: $composerId) {
      id

      metadata {
        id
        name
      }
    }
  }
`;
